import React, { Component } from 'react';
import './App.css';
import audioFile from './320905__suzenako__the-ding.wav';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breakLength: 5,
      sessionLength: 25,
      sessionTime: 1500000,
      breakTime: 300000,
      sessionRemaining: 1500000,
      breakRemaining: 300000,
      display: "25:00",
      status: "Session",
      playing: false
    };
    this.increaseSession = this.increaseSession.bind(this);
    this.increaseBreak = this.increaseBreak.bind(this);
    this.decreaseSession = this.decreaseSession.bind(this);
    this.decreaseBreak = this.decreaseBreak.bind(this);
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
     this.reset = this.reset.bind(this);
    this.processTime = this.processTime.bind(this);
  }
  
  beep = new Audio(audioFile);
  
  increaseSession(event) {
    if(this.state.sessionLength < 60) {
    this.reset();
    let temp = event.target.value;
      let temp2 = this.state.sessionLength;
    temp2 += 1;
    let temp3 = temp2 * 60000;
    let temp4 = this.timeConvert(temp3);
      this.setState({
        ...this.state,
      sessionLength: temp2,
        sessionTime: temp3,
        sessionRemaining: temp3,
        display: temp4,
        playing: false
    });
    }
    else {
      // alert("Session length must be less than sixty minutes.");
    }
  }
  
  decreaseSession(event) {
    if(this.state.sessionLength > 1) {
      this.reset();
    let temp = event.target.value;
      let temp2 = this.state.sessionLength;
    temp2 -= 1;
    let temp3 = temp2 * 60000;
    let temp4 = this.timeConvert(temp3);
      this.setState({
        ...this.state,
      sessionLength: temp2,
      sessionTime: temp3,
        sessionRemaining: temp3,
        display: temp4,
        playing: false
    });
    }
    else {
      // alert("Session length must be greater than zero!");
    }
  }
  
  increaseBreak(event) {
    if(this.state.breakLength < 60) {
    this.reset();
    let temp = event.target.value;
      let temp2 = this.state.breakLength;
    temp2 += 1;
    let temp3 = temp2 * 60000;
      this.setState({
        ...this.state,
      breakLength: temp2,
        breakTime: temp3,
        breakRemaining: temp3,
        playing: false
    });
    }
    else {
      // alert("Break length must be less than sixty minutes.");
    }
  }
  
  decreaseBreak(event) {
    if(this.state.breakLength > 1) {
    this.reset();
    let temp = event.target.value;
      let temp2 = this.state.breakLength;
    temp2 -= 1;
    let temp3 = temp2 * 60000;
      this.setState({
        ...this.state,
      breakLength: temp2,
        breakTime: temp3,
        breakRemaining: temp3,
        playing: false
    });
    }
    else {
      // alert("Break length must be greater than zero!");
    }
  }
  
 timeConvert(num) { 
  let min = Math.floor(num / 60000);  
  let sec = (num % 60000) / 1000;
   if (min < 10) {
     min = "0" + min;
   }
   if(sec==0) {
     sec = "00"
   }
   else if (sec < 10) {
     sec = "0" + sec;
   }
  return min + ":" + sec;         
}
  
  play() {
    if(!this.state.playing) {
    this.setState(
    {
      ...this.state,
      playing: true
    }
    );
    }
    else {
      this.setState(
    {
      ...this.state,
      playing: false
    });
    }
  }
  
  pause() {
    this.setState(
    {
      ...this.state,
      playing: false
    }
    );
  }
  
  reset() {
    this.setState(
    {
      breakLength: 5,
      sessionLength: 25,
      sessionTime: 1500000,
      breakTime: 300000,
      sessionRemaining: 1500000,
      breakRemaining: 300000,
      display: "25:00",
      status: "Session",
      playing: false
    }
    );
  }
  
  processTime() {
    if (this.state.playing) {
      
      if(this.state.status == 'Session') {
        if(this.state.sessionRemaining >= 1) {
        let newTime = this.state.sessionRemaining - 1000;
        let newDisplay = this.timeConvert(newTime);
        
        this.setState(
          {
          ...this.state,
          sessionRemaining: newTime,
          display: newDisplay
          }
        );
          if (newTime == 0) {
          this.beep.play();
        }
      }
      else {
        
        let newTime = this.state.breakRemaining;
        let newDisplay = this.timeConvert(newTime);
        this.setState(
          {
          ...this.state,
            status: "Break",
            breakRemaining: newTime,
          display: newDisplay
          }
        );
      }
      }
      else {
      if (this.state.breakRemaining >= 1) {
        let newTime = this.state.breakRemaining - 1000;
        let newDisplay = this.timeConvert(newTime);
        
        this.setState(
          {
          ...this.state,
          breakRemaining: newTime,
          display: newDisplay
          }
        );
        if (newTime == 0) {
          this.beep.play();
        }
      }
        else {
       let newBreak = this.state.breakTime;
          let newSession = this.state.sessionTime;
        let newDisplay = this.timeConvert(newSession);
        this.setState(
          {
          ...this.state,
          breakRemaining: newBreak,
            sessionRemaining: newSession,
          display: newDisplay,
            status: 'Session'
          }
        );
            }
      }
    }
  }
  
  componentDidMount() {
   let intervalId = setInterval(this.processTime, 1000);
}

  render() {
    return (
    <div>
        <audio id="beep" src="https://freesound.org/people/cdrk/sounds/264594/download/264594__cdrk__reception-bell.flac"></audio>
        <h1 className="headline">Pomodoro Cl<i className="fas fa-clock"></i>ck, Powered by React</h1>
        <p className="credit">Created by <a href="http://patrickvhessman.com/" target="_blank">Patrick Hessman</a></p>
        <div className="clockContainer">
        <div className="break cell"><h4 id="break-label">Break Length</h4>
          <i className="fas fa-arrow-down" onClick={this.decreaseBreak} id="break-decrement"></i> <span id="break-length">{this.state.breakLength}</span> <i className="fas fa-arrow-up" id="break-increment" onClick={this.increaseBreak}></i>
          </div>
        <div className="session cell"><h4 id="session-label">Session Length</h4>
         <i className="fas fa-arrow-down" id="session-decrement" onClick={this.decreaseSession}></i> <span id="session-length">{this.state.sessionLength}</span> <i className="fas fa-arrow-up" id="session-increment" onClick={this.increaseSession}></i> 
          </div>
        <div className="timer cell"><h3 id="timer-label">{this.state.status}</h3>
          <span className="countdown cell" id="time-left">{this.state.display}</span>
          </div>
          <div className="controls cell"><i className="fas fa-play" id="start_stop" onClick={this.play}></i> <i className="fas fa-pause" onClick={this.pause}></i> <i className="fas fa-sync-alt" id="reset" onClick={this.reset}></i></div>
        </div>
        </div>
    );
  }
}

export default App;
